<div class="container course-detail">
    <div class="box-default3 w-100 shadow-lg">
      <h4>Multidisciplinary Courses</h4>
        <img src="assets/img/course/mdc3.jpg" alt="MDC Image" class="img-fluid">
        <!-- <img src="assets/img/course/mdc2.jpg" alt="MDC Image" class="img-fluid"> -->
    </div>
</div>